import * as React from "react";
import type { LinkedMailArchiveDto } from "../../services/linkedMailService";

/**
 * Hinweis zur dauerhaften Sicherung einer verknüpften Mail — NUR wenn etwas zu
 * tun oder zu wissen ist. Die Sicherung läuft im Hintergrund; ob sie läuft,
 * fertig ist oder die Darstellung Eigenheiten hat, interessiert beim Lesen
 * niemanden (User 05.10.2026: „Gesichert/Eingeschränkt soll da nicht stehen").
 */
const labels: Partial<Record<LinkedMailArchiveDto["state"], string>> = {
    failed: "Diese Mail konnte nicht dauerhaft gesichert werden.",
    skipped: "Diese Mail ist zu groß für die dauerhafte Sicherung.",
    purged: "Die gesicherte Kopie dieser Mail wurde gelöscht.",
    missing: "Die gesicherte Kopie dieser Mail fehlt.",
};
export function MailCaptureStatus({ archive }: { archive?: LinkedMailArchiveDto }) {
    const text = archive ? labels[archive.state] : undefined;
    if (!text) return null;
    return <span role="status">{text}</span>;
}
